import { cx } from '@emotion/css';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router-dom';
import routing from 'routing';
import { IconTextField } from 'src/components/Default/IconTextField';
import { EllipsisText } from 'src/components/Main/News/EllipsisText';
import { useCoursesTemplates, useGenerateCourseFromTemplate, } from 'src/hooks/useCourses';
import { useFontSize } from 'src/hooks/useFontSize';
import useSearchParams from 'src/hooks/useSearchParams';
import CourseIcon from 'src/images/Icons/newIcons/navigation/courses.svg';

import { Header } from '../../../Main/ExamsBox/ExamsBox';
import { DefaultPicker } from './DefaultPicker';

export function CoursesTemplatesPicker() {
  const { fontSizeClass } = useFontSize();
  const history = useHistory();
  const { t } = useTranslation();
  const search = useSearchParams();
  const [folderIds] = useState(search?.folderId ? [search.folderId] : []);
  const [searchText, setSearchText] = useState('');
  const { data: templates, isLoading } = useCoursesTemplates({
    search: searchText,
  });
  const emptyText =
    templates?.length === 0 && !searchText
      ? t('contentPicker.courseType.emptyTemplates')
      : t('contentPicker.courseType.emptyText');

  const { mutateAsync } = useGenerateCourseFromTemplate();

  const generateCourse = async templateId => {
    const courseId = await mutateAsync({
      templateId,
      folderIds,
    });
    history.push(generatePath(routing.paths.course, { id: courseId }));
  };

  if (isLoading) {
    return null;
  }

  return (
    <DefaultPicker
      emptyText={emptyText}
      Header={
        <Header
          className="template-picker-header"
          title={t('contentPicker.courseType.title')}
          icon={<CourseIcon className={cx('icon-super-big icon-logo')} />}
          withBackButton
          Search={
            <IconTextField
              open
              isLoading={isLoading}
              onSearch={text => setSearchText(text)}
              onOpenClassName="user_questions_text_field-container"
              textFieldClassName="user_questions_text_field"
              placeholder={t('contentPicker.courseType.searchPlaceholder')}
            />
          }
        />
      }
      boxes={templates.map(template => {
        return {
          key: template.id,
          testId: `course-template-${template.id}`,
          title: template.name,
          subtitle: (
            <EllipsisText
              fontSizeClassName={fontSizeClass}
              className={`${fontSizeClass} fr-view text-ellipsis-4`}
              html={template.description}
            />
          ),
          submitText: t('contentPicker.courseType.templates.submit'),
          Icon: CourseIcon,
          variant: 'primary',
          onClick: () => generateCourse(template.id),
        };
      })}
    />
  );
}
